module.exports = __webpack_public_path__ + "img/main.a31cec90.png";